import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import OfficesSection from './components/OfficesSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <OfficesSection />
      <CTASection />
    </>
  );
}